import { render, staticRenderFns } from "./EnrollButton.vue?vue&type=template&id=f1070e9e&"
import script from "./EnrollButton.vue?vue&type=script&lang=js&"
export * from "./EnrollButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports